export default __webpack_public_path__ + "static/media/icon_claymore.63b1abb8.png";